import { DateTime } from "luxon";

export function buildReportFilename() {
  const dateFilename = DateTime.utc()
    .setZone("Asia/Bangkok")
    .toFormat("ddMMyy");

  return `subscription_recurring_${dateFilename}.xlsx`;
}

export function hasReportPayload(data) {
  if (data == null) {
    return false;
  }

  if (data instanceof ArrayBuffer) {
    return data.byteLength > 0;
  }

  if (ArrayBuffer.isView(data)) {
    return data.byteLength > 0;
  }

  if (typeof Blob !== "undefined" && data instanceof Blob) {
    return data.size > 0;
  }

  return true;
}

export function downloadBlob(blobData, fileName) {
  const blob = new Blob([blobData]);
  const url = window.URL.createObjectURL(blob);

  try {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } finally {
    window.URL.revokeObjectURL(url);
  }
}
